import { render, staticRenderFns } from "./sapPartner.vue?vue&type=template&id=6c00bb2e"
import script from "./sapPartner.vue?vue&type=script&lang=js"
export * from "./sapPartner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports